import "./TextBlock.scss";
import { useEffect, useRef } from "react";
import gsap from "gsap";

function TextBlock(props) {
  const tl = useRef();

  useEffect(() => {
    // tl.current = gsap.timeline({});
    // tl.current.fromTo(
    //   logo.current,
    //   { autoAlpha: 0, y: 20 },
    //   { autoAlpha: 1, duration: 2, y: 0 }
    // );
  }, []);

  return (
    <div
      id={props.id}
      className={`text-block ${
        props.background ? props.background : ""
      }Background`}
    >
      <div className="titles">
        {props.data.text.map((t, i) => {
          return (
            <h1
              key={props.id + "texttblock" + i}
              className={`title ${t.color} ${t.align ? t.align : ""}`}
            >
              <span className="title-number black">{"0" + (i + 1)}</span>{" "}
              {t.text}
            </h1>
          );
        })}
      </div>
      <div className="section-labels">
        <div
          className={`section-title ${props.color}`}
        >{`(${props.section})`}</div>
        <div className={`section-number`}>{`●  ${
          props.count < 10 ? "0" + props.count : props.count
        } / ${props.total < 10 ? "0" + props.total : props.total}`}</div>
      </div>
    </div>
  );
}

export default TextBlock;
